import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRoleMain, MasterPages } from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { Header } from "../../../Components/Header/Header";
// import fullImage1 from '../../../FrontEnd/Images/Banner/1.jpg'
import { useDispatch } from "react-redux";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import WSDataGridForDashboard from "../../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import ConfirmationDashboardPopup from "../../../Components/Confirmation/ConfirmationDashboard";
import { IRows } from "../../../Components/Filter/WSFilterComponent";

export const SupplierList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();
    const source = {
        url: "Supplier/search",
        page: 1,
        pageSize: 10,
        filter: [
       
    ],
        sort: [],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/Supplier/${row?.id}`)
        }
        if (action === 'Delete') {
            setSelectedId(row.id); // Set the ID of the row to be deleted
            setPopupOpen(true)
        }
    };
    const columns: IColumns[] = [
    
        {
            header: "Name",
            fieldName: "name",
            type: "default",
        },
        // {
        //     header: "Contact",
        //     fieldName: "contact",
        //     type: "default",
        // },
        {
            header: "Category",
            fieldName: "category",
            type: "default",
        },
       
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [ "Edit" , 'Delete'],
            actionCallback: (action, row) => handleAction(action, row),
        },

    ];

    const handleClick = () => {
        navigate('/supplier/create')
    }
    const handleDelete = (response: any) => {
        dispatch(resetDataComponent('supplierlist'));
        showMessage('Supplier deleted successfully!', 'success')
    };
     const filterRows: IRows[] = [
            {
                label: "Name",
                fieldName: "Name",
                type:'text',
                operator: 'like'
            },
            {
                label: "Category",
                fieldName: "Category",
                type: "text",
                operator: 'like'
            },
    
        ];
    return (
        <>  <Grid item container spacing={2}>
            {/* <Grid item sm={12} xs={12}>
                <WSImageView imgUrl={fullImage1} isAnimated={false} imageSx={{ height: 300 }} />
            </Grid> */}
            <Grid item sm={12} xs={12}>
                <Divider />
            </Grid>
        </Grid>
            <Header type="simple" isDivider={true} title="Suppliers" id={'suppliersim'} headerSx={{ marginTop: 0 }} />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <WSDataGridForDashboard
                        id="supplierlist"
                        title="Suppliers"
                        columns={columns}
                        source={source}
                        filterFields={filterRows}
                        searchBox={{ fieldName: 'Name' }}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    {selectedId !== null && <ConfirmationDashboardPopup
                        apiUrl={'Supplier/'}
                        id={selectedId}
                        confirmMessage="Are you sure you want to delete this item?"
                        open={isPopupOpen}
                        onClose={() => setPopupOpen(false)}
                        onConfirm={handleDelete}
                    />}
                </Grid>
            </Grid>
        </>
    )
})